import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import {
  TextField,
  Container,
  Typography,
  Grid,
  Box,
  Stack,
  IconButton,
  Card,
  Radio,
  Chip,
  CircularProgress,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import { getTemplateDetail } from "src/DAL/FormTemplate/feedbackTemplates";
import { makeStyles } from "@mui/styles";
import AvatarGallery from "./component/imageViewOnLength";
import RecordNotFound from "src/components/RecordNotFound";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
export default function TemplatePreview() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const param = useParams();
  const _id = param.id;
  const classes = useStyles();
  const [templateTitle, setTemplateTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("");

  async function getDetailsOfSurveyTemplate() {
    const res = await getTemplateDetail(_id);
    if (res.code === 200) {
      let data = [];
      res?.form_template?.questions.map((item) => {
        data.push({ display: false });
      });

      setTemplateTitle(res?.form_template?.title);
      setQuestions(res?.form_template?.questions);
      setTemplateDescription(res?.form_template?.description);
      setIsLoading(false);
    } else {
      enqueueSnackbar(res.message, { variant: "error" });
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getDetailsOfSurveyTemplate();
  }, []);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <Container sx={{ width: { sm: 950, md: 950 } }}>
      <Stack
        direction="column"
        alignItems="left"
        justifyContent="space-between"
      >
        <div className="col-12">
          <IconButton
            className="back-screen-button mb-4"
            onClick={() => navigate(-1)}
          >
            <Icon icon="akar-icons:arrow-left" />
          </IconButton>
        </div>
      </Stack>
      <>
        <Stack
          direction="column"
          alignItems="center"
          spacing={1.5}
          justifyContent="space-between"
          mb={4.5}
        >
          <h2 className="text-start w-100">{templateTitle}</h2>

          <Typography
            className="text-start w-100"
            sx={{ fontWeight: "500", fontSize: 16, opacity: 0.6 }}
          >
            {templateDescription}
          </Typography>
          {questions.length > 0 ? (
            questions.map((item, index) => {
              return (
                <Card
                  className="w-100"
                  sx={{
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    mb: 1,
                    width: { sm: "100%", md: "100%" },
                    margin: "auto",
                    p: 2,
                    backgroundColor: "",
                    borderRadius: 0.5,
                    position: "relative",
                  }}
                >
                  {item?.required && (
                    <Chip
                      label={"Required"}
                      variant="contained"
                      color={"error"}
                      sx={{
                        fontSize: "10px",
                        height: "auto",
                        width: "auto",
                        position: "absolute",
                        top: 8,
                        left: 16,
                      }}
                    />
                  )}
                  <Box sx={{ width: "100%", margin: "auto" }} margin={0}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={{ xs: 0, sm: 0, md: 2 }}
                      mt={1}
                    >
                      <Grid item md={12} xs={12}>
                        <div className="d-flex align-items-center mb-2">
                          <div className="">
                            <Typography
                              sx={{ fontWeight: "900", fontSize: 16, mr: 1 }}
                            >
                              Q{index + 1}.
                            </Typography>
                          </div>
                          <div>
                            <Typography
                              variant="body1"
                              sx={{ fontSize: 14, mr: 1 }}
                            >
                              {item?.title}
                            </Typography>
                          </div>
                        </div>
                      </Grid>

                      {item?.type == "multiple_choice" ? (
                        <Grid item md={12} xs={12}>
                          {item?.options.map((item) => {
                            return (
                              <Grid item md={12}>
                                <div className="d-flex align-items-center mb-2">
                                  <div>
                                    <Radio disabled />
                                  </div>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      fontSize: 14,
                                      mr: 1,
                                    }}
                                  >
                                    {item}
                                  </Typography>
                                </div>
                              </Grid>
                            );
                          })}
                        </Grid>
                      ) : item?.type == "multiple_select" ? (
                        <Grid item md={12} xs={12}>
                          {item?.options.map((item) => {
                            return (
                              <Grid item md={12}>
                                <div className="d-flex align-items-center mb-2">
                                  <div>
                                    <Radio disabled />
                                  </div>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      fontSize: 14,
                                      mr: 1,
                                    }}
                                  >
                                    {item}
                                  </Typography>
                                </div>
                              </Grid>
                            );
                          })}
                        </Grid>
                      ) : item?.type == "image" ? (
                        <Grid item md={12} xs={12}>
                          <div className="d-flex align-items-center mb-2">
                            <div className="">
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                  fontSize: 14,
                                  mr: 1,
                                }}
                              >
                                {item?.options[0]}
                              </Typography>
                            </div>

                            <AvatarGallery length={item?.options_count} />
                            <div className="">
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                  fontSize: 14,
                                  ml: 1,
                                }}
                              >
                                {item?.options[1]}
                              </Typography>
                            </div>
                          </div>
                        </Grid>
                      ) : item?.type == "free_text" ? (
                        <Grid item md={12} xs={12}>
                          <TextField
                            id="outlined-multiline-static"
                            label="Answer"
                            multiline
                            disabled
                            rows={4}
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                      ) : (
                        item?.type == "signature" && (
                          <Grid item md={12} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              multiline
                              disabled
                              rows={4}
                              sx={{
                                width: "100%",
                                "& fieldset": {
                                  top: 0,
                                },
                                "& legend": {
                                  display: "none",
                                },
                              }}
                            />
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Box>
                </Card>
              );
            })
          ) : (
            <RecordNotFound title="Questions" />
          )}
        </Stack>
      </>
    </Container>
  );
}
